module.exports = __webpack_public_path__ + "img/file-text.571c137d.svg";